<template>
  <BaseDrawer :is-open="isOpen" @close="emit('close')">
    <DrawerHeader @close="emit('close')">
      <template v-if="currentOrder.orderNumber"
        >Order #{{ currentOrder.orderNumber }}
      </template>
      <template v-else> Order </template>
    </DrawerHeader>
    <ConfigureOrderForm
      :initial-values="initialValues"
      @submit="onSubmit"
      @cancel="emit('close')"
    />
  </BaseDrawer>
</template>

<script setup lang="ts">
import type {
  ConfigureOrderFormOutput,
  ConfigureOrderFormInput,
} from "@/forms/configureOrderForm"

defineProps<{ isOpen: boolean }>()

const emit = defineEmits<{
  (event: "close"): void
}>()

const { currentOrder, setFromConfigureOrderForm } =
  useCurrentOrder()

const initialValues = computed<ConfigureOrderFormInput>(
  () => ({
    note: currentOrder.value.note ?? "",
    serviceChargePercentage:
      currentOrder.value.serviceChargePercentage ?? 0,
    serviceChargeFlat:
      currentOrder.value.serviceChargeFlat ?? 0,
  })
)

const onSubmit = (formValues: ConfigureOrderFormOutput) => {
  setFromConfigureOrderForm(formValues)
  emit("close")
}
</script>
